import React from 'react';
import styled from 'styled-components';

import { StudentPlatformsAccess } from './student-platforms-access';
import { StudentGeneralAccess } from './student-general-access';

import type { StudentEntity } from '@modules/students/entities';

type StudentAccessFormGroupProps = {
    student: StudentEntity;
    canViewAccess: boolean;
    canCreateAccess: boolean;
    canSendAccess: boolean;
    canDeleteAccess: boolean;
};

const Form = styled.div`
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;

    > *:not(:last-child) {
        margin-bottom: 24px;
    }
`;

const StudentAccessFormGroup = (props: StudentAccessFormGroupProps): React.ReactElement => {
    const { student, canViewAccess, canCreateAccess, canDeleteAccess, canSendAccess } = props;

    return (
        <Form>
            {canViewAccess ? (
                <StudentPlatformsAccess
                    student={student}
                    canCreate={canCreateAccess}
                    canDelete={canDeleteAccess}
                />
            ) : null}

            {canSendAccess ? <StudentGeneralAccess student={student} /> : null}
        </Form>
    );
};

export { StudentAccessFormGroup };
